// extracted by mini-css-extract-plugin
export default {"success":"styles-success-c317ea","light":"styles-light-bcc08c","error":"styles-error-ba1545"};